import React from "react";
import LegalLayout from "./LegalLayout";

export default function ShippingPolicy() {
  return (
    <LegalLayout title="Shipping & Delivery Policy" seoKey="shipping-delivery-policy">
      <p>Gulfudaan primarily provides digital services. This policy explains how deliverables are shared with customers.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Digital Delivery</h3>
      <p>Confirmations for GAMCA appointments, dummy tickets, hotel bookings, and VFS/skill test appointment slips are delivered digitally via WhatsApp and/or email within the timelines mentioned on each service page.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Delivery Timelines</h3>
      <p>Most services are delivered within 15 minutes to 48 hours depending on the service selected. Estimated timelines are mentioned on each respective service page.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Delays</h3>
      <p>While we strive to meet all stated timelines, delays may occur due to third-party center availability (GAMCA/VFS) beyond our control. We will keep you informed via WhatsApp in such cases.</p>
      <h3 className="font-heading text-xl text-[#1A1A1A] pt-4">Contact</h3>
      <p>For delivery-related queries, reach us at help@gulfudaan.com or +91 73143 44673.</p>
    </LegalLayout>
  );
}
